import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowUp"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0002 2.37869L19.6215 10L17.5002 12.1213L13.5002 8.12132V21H10.5002V8.12134L6.50023 12.1213L4.37891 10L12.0002 2.37869Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowUp;
